import { SparklesIcon, ShiftsIcon, PeopleIcon, ReportsIcon, VenuesIcon } from '../../assets/svg';

export const MENU_ITEMS = [
  { text: 'Tempo', icon: SparklesIcon, path: '/' },
  { text: 'Shifts', icon: ShiftsIcon, path: '/shifts' },
  { text: 'People', icon: PeopleIcon, path: '/people' },
];

export const ROLES = {
  OWNER: 'OWNER',
  MANAGER: 'MANAGER',
  EMPLOYEE: 'EMPLOYEE',
};

export const PROTECTED_MENU_ITEMS = [
  { text: 'Reports', icon: ReportsIcon, path: '/reports' },
  { text: 'Venues', icon: VenuesIcon, path: '/venues' },
];
